import { formControlLabelClasses } from '@mui/material/FormControlLabel';
import { formLabelClasses } from '@mui/material/FormLabel';
import { radioClasses } from '@mui/material/Radio';
import { colors } from '../constants';
const styleOverrides = {
  root: {
    alignItems: 'start',
    [`& .${radioClasses.checked}`]: {
      [`&, & + .${formControlLabelClasses.label}`]: {
        color: colors.text.active
      }
    },
    [`& .${formLabelClasses.disabled}`]: {
      [`&, & + .${formControlLabelClasses.label}`]: {
        color: colors.text.disabled
      }
    }
  },
  label: {
    paddingTop: 11
  }
};
export default {
  styleOverrides
};
//# sourceMappingURL=MuiFormControlLabel.js.map